var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c("div", { staticClass: "row notification-panel" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "form",
            {
              attrs: {
                autocomplete: "off",
                method: "post",
                "data-vv-scope": "notification",
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "MaterialSelect",
                            {
                              staticClass: "city-form-group city-bg mt-0",
                              attrs: {
                                id: "input-notification",
                                name: "notification",
                                label: "name",
                                filterable: true,
                                options: _vm.lists.templates,
                              },
                              on: { input: _vm.onChangeTemplate },
                              model: {
                                value: _vm.form.notification_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "notification_id",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.notification_id",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Template\n                                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.lists.channels.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-auto d-flex align-items-center",
                          },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Canal")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-wrap d-sm-inline-flex flex-sm-wrap",
                                },
                                _vm._l(
                                  _vm.lists.channels,
                                  function (channel, idx) {
                                    return _c(
                                      "div",
                                      {
                                        key: `channel-${idx}`,
                                        staticClass:
                                          "form-check city-form-check",
                                        class: [
                                          {
                                            "is-invalid": _vm.fnHasError(
                                              `channels`,
                                              "notification"
                                            ),
                                          },
                                        ],
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.form.channel_id,
                                              expression: "form.channel_id",
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: { required: true },
                                              expression: "{'required': true}",
                                            },
                                          ],
                                          staticClass: "form-check-input",
                                          attrs: {
                                            type: "radio",
                                            id: `cb-channel-${channel.id}`,
                                            name: `channels`,
                                          },
                                          domProps: {
                                            value: channel.id,
                                            checked: _vm._q(
                                              _vm.form.channel_id,
                                              channel.id
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.form,
                                                "channel_id",
                                                channel.id
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "form-check-label",
                                            attrs: {
                                              for: `cb-channel-${channel.id}`,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(channel.name) +
                                                "\n                                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.lists.targets.length
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Alvos para Notificação")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-wrap d-sm-inline-flex flex-sm-wrap",
                              },
                              [
                                _vm._l(
                                  _vm.lists.targets,
                                  function (target, idx) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          key: idx,
                                          staticClass:
                                            "form-check city-form-check",
                                          class: [
                                            {
                                              "is-invalid": _vm.fnHasError(
                                                `targets`,
                                                "notification"
                                              ),
                                            },
                                          ],
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.form.targets,
                                                expression: "form.targets",
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: _vm.form
                                                    .otherTargets
                                                    ? false
                                                    : true,
                                                },
                                                expression:
                                                  "{'required': form.otherTargets ? false : true}",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              type: "checkbox",
                                              id: `cb-target-${target.id}`,
                                              name: `targets`,
                                            },
                                            domProps: {
                                              value: target,
                                              checked: Array.isArray(
                                                _vm.form.targets
                                              )
                                                ? _vm._i(
                                                    _vm.form.targets,
                                                    target
                                                  ) > -1
                                                : _vm.form.targets,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.form.targets,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = target,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.form,
                                                        "targets",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.form,
                                                        "targets",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "targets",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "form-check-label",
                                              attrs: {
                                                for: `cb-target-${target.id}`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(target.name) +
                                                  "\n                                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-check city-form-check",
                                    class: [
                                      {
                                        "is-invalid": _vm.fnHasError(
                                          "target-other",
                                          "notification"
                                        ),
                                      },
                                    ],
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.otherTargets,
                                          expression: "form.otherTargets",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required:
                                              _vm.form.otherTargets ||
                                              _vm.form.targets.length == 0
                                                ? true
                                                : false,
                                          },
                                          expression:
                                            "{'required': form.otherTargets || form.targets.length == 0 ? true : false}",
                                        },
                                      ],
                                      staticClass: "form-check-input",
                                      attrs: {
                                        type: "checkbox",
                                        id: "target-other",
                                        name: "target-other",
                                      },
                                      domProps: {
                                        value: _vm.form.otherTargets,
                                        checked: Array.isArray(
                                          _vm.form.otherTargets
                                        )
                                          ? _vm._i(
                                              _vm.form.otherTargets,
                                              _vm.form.otherTargets
                                            ) > -1
                                          : _vm.form.otherTargets,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.form.otherTargets,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = _vm.form.otherTargets,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "otherTargets",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "otherTargets",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.form,
                                              "otherTargets",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form-check-label",
                                        attrs: { for: "target-other" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                Outro\n                                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.form.otherTargets
                          ? _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c(
                                  "MaterialInput",
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.getRule("contacts"),
                                        expression: "getRule('contacts')",
                                      },
                                    ],
                                    staticClass: "city-form-group city-bg",
                                    attrs: {
                                      type: "text",
                                      id: "input-contacts",
                                      name: "contacts",
                                      inputClasses: [
                                        {
                                          "is-invalid": _vm.fnHasError(
                                            "contacts",
                                            "notification"
                                          ),
                                        },
                                      ],
                                      error: _vm.fnFirstError(
                                        "contacts",
                                        "notification"
                                      ),
                                      helpText: `Utilizar '${_vm.separatorContacts}' para separar os contatos.`,
                                    },
                                    model: {
                                      value: _vm.form.contacts,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "contacts", $$v)
                                      },
                                      expression: "form.contacts",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\tContatos\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "MaterialInput",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.getRule("subject"),
                                  expression: "getRule('subject')",
                                },
                              ],
                              staticClass: "city-form-group city-bg",
                              attrs: {
                                readonly: !_vm.activeSubjectField,
                                disabled: !_vm.activeSubjectField,
                                type: "text",
                                id: "input-subject",
                                name: "subject",
                                inputClasses: [
                                  {
                                    "is-invalid": _vm.fnHasError(
                                      "subject",
                                      "notification"
                                    ),
                                  },
                                ],
                                error: _vm.fnFirstError(
                                  "subject",
                                  "notification"
                                ),
                              },
                              model: {
                                value: _vm.replaceTagsSubject,
                                callback: function ($$v) {
                                  _vm.replaceTagsSubject = $$v
                                },
                                expression: "replaceTagsSubject",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t\tAssunto\n\t\t\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Mensagem")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "city-form-group mb-0" },
                          [
                            _c("ckeditor", {
                              staticClass: "form-control",
                              attrs: {
                                editor: _vm.cKEditor.editor,
                                config: _vm.cKEditor.editorConfig,
                              },
                              model: {
                                value: _vm.replaceTagsMessage,
                                callback: function ($$v) {
                                  _vm.replaceTagsMessage = $$v
                                },
                                expression: "replaceTagsMessage",
                              },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.plainMessage,
                                  expression: "plainMessage",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.getRule("message"),
                                  expression: "getRule('message')",
                                },
                              ],
                              attrs: { type: "hidden", name: "message" },
                              domProps: { value: _vm.plainMessage },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.plainMessage = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.fnHasError("message", "notification")
                              ? _c(
                                  "small",
                                  { staticClass: "d-block invalid-feedback" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.fnFirstError(
                                          "message",
                                          "notification"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeFilesField,
                          expression: "activeFilesField",
                        },
                      ],
                      staticClass: "row",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("upload-multiple-file", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "",
                                expression: "''",
                              },
                            ],
                            attrs: {
                              acceptTypes: _vm.acceptTypes,
                              maxFiles: _vm.maxFiles,
                              name: "files",
                              errorText: _vm.fnFirstError(
                                "files",
                                "notification"
                              ),
                            },
                            model: {
                              value: _vm.files,
                              callback: function ($$v) {
                                _vm.files = $$v
                              },
                              expression: "files",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row pt-sm-3" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "row d-flex justify-content-center" },
                        [
                          _vm.allowCancel
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-sm-4 order-2 pb-3 pb-sm-0",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-outline-main btn-rounded btn-md btn-responsive btn-block min-w-auto",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.cancelMessage.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.btnCancelTitle))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.allowSend
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-sm-4 order-1 order-sm-4 pb-3 pb-sm-0",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-main btn-rounded btn-md btn-responsive btn-block min-w-auto",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.sendMessage.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.btnSendTitle))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }